// extracted by mini-css-extract-plugin
export default {"audio-button":"AudioButton_audio-button__mQXtp App_--rubber-fx-for-big-btns__9g0A2 App_--rubber-fx__yYj6p App_--no-drag__UPMNo"};